/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updatePayersForCustomer} from '../api'

export const useMutationUpdatePayersForCustomer = createReactQueryMutationHook('updatePayersForCustomer', updatePayersForCustomer)
